import Actions             from 'Redux/Actions';
import { EventRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from }            from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findEventsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventsRequest.type),
    mergeMap(action => from(
      EventRepository.findAll(action.payload)
        .then(({ events, meta }) => Actions.findEventsSuccess({ events, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findEventsFailure({ error })),
    )),
  );
};
